import axios from 'axios'

/**
 * authLogin 用户登录
 * queryUserMenuList 查询侧边栏
 * queryButtonPermission 查询用户可见按钮
 */

// 客服登录
export function authLogin (datas) {
  const url = `/customerLogin/login`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取客服工单列表
export function customerWorkOrder (datas) {
  const url = `/customerWorkOrder`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 新增客服工单
export function addCustomerWorkOrder (datas) {
  const url = `/customerWorkOrder`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 编辑客服工单
export function editCustomerWorkOrder (datas) {
  const url = `/customerWorkOrder`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取客服工单详情
export function queryCustomerWorkOrderDetail (datas) {
  const url = `/customerWorkOrder/queryCustomerWorkOrderDetail`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取单个客服工单操作历史记录列表
export function queryCustomerHistoryRecordList (datas) {
  const url = `/customerHistoryRecord/queryCustomerHistoryRecordList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取有权限的客服列表
export function queryJurisdictionCustomerList (datas) {
  const url = `/customerWorkOrder/queryJurisdictionCustomerList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 工单指派
export function customerWorkOrderAssign (datas) {
  const url = `/customerWorkOrder/customerWorkOrderAssign`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 客服工单状态变更
export function customerWorkOrderChangeStatus (datas) {
  const url = `/customerWorkOrder/customerWorkOrderChangeStatus`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 工单跟进
export function customerWorkOrderFollowUp (datas) {
  const url = `/customerWorkOrder/customerWorkOrderFollowUp`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 客服工单导出
export function exportCustomerWorkOrderList (datas) {
  const url = `/customerWorkOrder/exportCustomerWorkOrderList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取多类型列表
export function queryManyTypeList (datas) {
  const url = `/sysDictionary/queryManyTypeList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取类型列表
export function queryBusinessTypeList (datas) {
  const url = `/sysDictionary/queryBusinessTypeList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 账号管理重置密码
export function editUserPwd (datas) {
  const url = `/customerPermission/editUserPwd`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 新增/编辑工单问题分类
export function saveSysDictionaryType (datas) {
  const url = `/sysDictionary/saveSysDictionaryType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 删除工单问题分类
export function delSysDictionaryType (datas) {
  const url = `/sysDictionary/delSysDictionaryType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 工单转移
export function transferSysDictionaryType (datas) {
  const url = `/sysDictionary/transferSysDictionaryType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 问题分类详情列表
export function querySysDictionaryListByType (datas) {
  const url = `/sysDictionary/querySysDictionaryListByType`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询工单详情
// export function queryWorkContentRecord (datas) {
//   const url = `/customerWorkOrder/queryWorkContentRecord`
//   return new Promise((resolve, reject) => {
//     axios.get(url, { params: datas }).then((res) => {
//       resolve(res)
//     }).catch((err) => {
//       reject(err)
//     })
//   })
// }

// 查询工单聊天记录(非ai生成)
export function queryWorkContentRecord (datas) {
  const url = `/customerWorkOrder/queryWorkContentRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询工单聊天记录(ai生成)
export function queryAIWorkContentRecord (datas) {
  const url = `/customerWorkOrder/queryAIWorkContentRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/order/index.js